import React from 'react';
import Slider from 'rc-slider';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import { Map } from 'immutable';
import { WithTooltip } from '@shoflo-rundown/polymer.legacy';
import {
  FontWeights,
  ZoomPercentages,
  ZoomPercentageDefaultIndex,
  PrompterWidths,
  LineHeightPercentages,
  LineHeightPercentageDefaultIndex,
  AutoScrollSpeeds,
} from 'shared/constants/FeaturedEditorConstants';
import { fromJS } from 'immutable';
import RouteActions from 'flux/actions/RouteActions';
import FullScreenCuesheetActions from 'flux/actions/cuesheet.fullscreen/FullScreenCuesheetActions';
import classNames from 'classnames';
import moment from 'moment';
import readingTime from 'reading-time';
import ColumnMenu from 'shared/components/menus/columns';
import { ToggleSwitch } from '@shoflo-rundown/polymer.legacy';
import { isMac } from 'shared/lib/platformCheck';
import Button from 'shared/components/misc/button.jsx';
import ModalActions from 'flux/actions/ModalActions';
import UIRegions from 'shared/constants/UIRegions';
import _ from 'underscore';
//import Dropdown from 'shared/components/menus/dropDown.jsx';

const { createSliderWithTooltip } = Slider;
const TooltipSlider = createSliderWithTooltip(Slider);

// NOTE THIS FILE HAS MANY PROP TYPE VIOLATIONS
// AND ALL ARE DISABLED BY THE COMMENT BELOW.
/* eslint-disable react/prop-types */

class UtilityPanel extends React.Component {
  constructor(props) {
    super(props);
    this._handleShowSelection = this._handleShowSelection.bind(this);
    this._toggleUtilityPanelDisplay = this._toggleUtilityPanelDisplay.bind(
      this,
    );
    this._onToggleBold = this._onToggleBold.bind(this);
    this._onToggleItemInfo = this._onToggleItemInfo.bind(this);
    this._toggleRealTimeItem = this._toggleRealTimeItem.bind(this);
    this._toggleSingleItem = this._toggleSingleItem.bind(this);
    this._toggleReadArrow = this._toggleReadArrow.bind(this);
    this._toggleCaps = this._toggleCaps.bind(this);
    this._toggleTextMirror = this._toggleTextMirror.bind(this);
    this._toggleVerticalMirror = this._toggleVerticalMirror.bind(this);
    this._setAutoScrollSpeed = this._setAutoScrollSpeed.bind(this);
    this._setPrompterWidth = this._setPrompterWidth.bind(this);
    this._setLineHeight = this._setLineHeight.bind(this);
    this._setZoom = this._setZoom.bind(this);
    this._openRemoteTeleprompterModal = this._openRemoteTeleprompterModal.bind(
      this,
    );
    this._getActiveTab = this._getActiveTab.bind(this);
    this._getStylesTab = this._getStylesTab.bind(this);
    this._setStylesTabActive = this._setStylesTabActive.bind(this);
    this._setSettingsTabActive = this._setSettingsTabActive.bind(this);
    this._getSettingsTab = this._getSettingsTab.bind(this);
    this._getColumnSelectorNode = this._getColumnSelectorNode.bind(this);
    this.state = {
      activeTab: props.hasSeenOnboardingColumnSelection ? 'styles' : 'settings',
      operator: '',
    };

    this.throttledSetLineHeight = _.debounce(props.onLineHeightChange, 500);
    this.throttledSetZoom = _.debounce(props.onZoomChange, 500);
  }

  componentDidMount() {
    this._initialDisplayTimeout = setTimeout(() => {
      this._togglePanelDisplay(false);
    }, 3000);
  }

  render() {
    const { open, width } = this.props;
    return (
      <div
        id="fullscreen-utility-panel"
        className={classNames({ open: open, 'close-panel': !open })}
      >
        <div className="flex flex-row flex-grow-1">
          <div className="tab-container right">
            <div
              id="right-fullscreen-tab"
              onClick={this._toggleUtilityPanelDisplay}
            />
          </div>
          <div
            style={{ width }}
            className={classNames(
              'flex-column',
              'featured-utility-panel-content-wrapper',
              { sneak: !open },
            )}
          >
            <div className="featured-utility-panel-content">
              {this._getTabs()}
              {this._getActiveTab()}
              <Button
                className="teleprompter-close-btn"
                onClick={this._toggleUtilityPanelDisplay}
              >
                <Icon name="arrow-circle-right" />
                Close
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  _toggleUtilityPanelDisplay() {
    const { open } = this.props;
    FullScreenCuesheetActions.togglePanel('utilityPanel', !open);
  }

  _togglePanelDisplay(display) {
    if (display && this._initialDisplayTimeout) {
      clearTimeout(this._initialDisplayTimeout);
      delete this._initialDisplayTimeout;
    }

    const clearPanelTimeout = () => {
      clearTimeout(this._hidePanelTimeout);
      delete this._hidePanelTimeout;
    };

    if (this._hidePanelTimeout) {
      clearPanelTimeout();
    }

    /**
     * Add a three second delay to modal closing
     */
    if (display === false) {
      this._hidePanelTimeout = setTimeout(() => {
        FullScreenCuesheetActions.togglePanel('utilityPanel', display);
        clearPanelTimeout();
      }, 500);
    } else {
      FullScreenCuesheetActions.togglePanel('utilityPanel', display);
    }
  }

  _getLoadingClasses() {
    const { loading } = this.props;

    const loadingClasses = {
      loading: loading ? 'loading' : 'loaded',
      animation: loading ? 'loading-animation' : '',
    };

    return loadingClasses;
  }

  _openRemoteTeleprompterModal() {
    ModalActions.show(UIRegions.RemoteTeleprompter);
  }

  _getColumnSelectorNode() {
    const {
      columnId,
      columns,
      hasSeenOnboardingColumnSelection,
      onColumnChange,
    } = this.props;

    const { loading, animation } = this._getLoadingClasses();

    return (
      <div
        className={classNames(animation, 'featured-utility-panel-column-menu')}
      >
        <span className={classNames(loading)}>
          <p>
            <span>Prompter column:</span>
            <WithTooltip
              delay={100}
              placement="top"
              tip="Select a column to display prompter text"
            >
              <div>
                <Icon name="info-circle" />
              </div>
            </WithTooltip>
          </p>
          <ColumnMenu
            columns={fromJS(columns)}
            activeId={hasSeenOnboardingColumnSelection ? columnId : null}
            onChange={onColumnChange}
          />
        </span>
      </div>
    );
  }

  _getStylesTab() {
    const {
      autoScrollSpeedIndex,
      featuredZoom,
      featuredLineHeight,
      prompterWidthIndex,
    } = this.props;

    const textSizeHotkey = isMac() ? '⌥' : 'Alt';
    const lineHeightHotkey = isMac() ? '⌥' : 'Alt';
    const prompterWidthHotkey = isMac() ? '⇧ + ⌘' : 'Shift + Ctrl';

    const { loading, animation } = this._getLoadingClasses();

    let zoomIndex = Object.keys(ZoomPercentages).find(
      (key) => ZoomPercentages[key] === featuredZoom,
    );
    zoomIndex =
      !zoomIndex || zoomIndex === -1
        ? ZoomPercentageDefaultIndex
        : parseInt(zoomIndex);

    let propsLineHeightIndex = parseInt(
      Object.keys(LineHeightPercentages).find((key) => {
        return LineHeightPercentages[key] === featuredLineHeight;
      }),
      10,
    );

    if (!propsLineHeightIndex && propsLineHeightIndex !== 0)
      propsLineHeightIndex = LineHeightPercentageDefaultIndex;

    let {
      autoScrollSliderIndex,
      lineHeightSliderIndex,
      prompterWidthSliderIndex,
      zoomSliderIndex,
    } = this.state;
    if (autoScrollSliderIndex === undefined)
      autoScrollSliderIndex = autoScrollSpeedIndex;
    if (zoomSliderIndex === undefined) zoomSliderIndex = zoomIndex;
    if (prompterWidthSliderIndex === undefined)
      prompterWidthSliderIndex = prompterWidthIndex;

    const lineHeightIndex = lineHeightSliderIndex || propsLineHeightIndex;

    return (
      <div className="featured-utility-panel-sliders-wrapper">
        <span
          className={classNames(animation, 'featured-utility-panel-slider')}
        >
          <span className={classNames(loading)}>
            <div className="fullscreen-switch-featured-text">
              Text Size
              <WithTooltip
                delay={100}
                placement="top"
                tip={`Use ${textSizeHotkey} and - or +`}
              >
                <div>
                  <Icon name="info-circle" />
                </div>
              </WithTooltip>
            </div>
            <div className="rc-slider-wrapper" id="prompter-text-size-slider">
              <TooltipSlider
                min={1}
                max={Object.keys(ZoomPercentages).length}
                step={1}
                value={zoomSliderIndex}
                onChange={this._setZoom}
              />
              <span className="slider-value">{zoomIndex}</span>
            </div>
          </span>
        </span>
        <span
          className={classNames(animation, 'featured-utility-panel-slider')}
        >
          <span className={classNames(loading)}>
            <div className="fullscreen-switch-featured-text">
              Line Height
              <WithTooltip
                delay={100}
                placement="top"
                tip={`Use ${lineHeightHotkey} and [ or ]`}
              >
                <div>
                  <Icon name="info-circle" />
                </div>
              </WithTooltip>
            </div>
            <div className="rc-slider-wrapper" id="prompter-line-height-slider">
              <TooltipSlider
                min={1}
                max={Object.keys(LineHeightPercentages).length}
                step={1}
                value={lineHeightIndex}
                onChange={this._setLineHeight}
              />
              <span className="slider-value">{lineHeightIndex}</span>
            </div>
          </span>
        </span>
        <span
          className={classNames(animation, 'featured-utility-panel-slider')}
        >
          <span className={classNames(loading)}>
            <div className="fullscreen-switch-featured-text">
              Speed / Direction
              <WithTooltip
                delay={100}
                placement="top"
                tip="Spacebar to start scroll \n UP / DOWN keys for speed"
              >
                <div>
                  <Icon name="info-circle" />
                </div>
              </WithTooltip>
            </div>
            <div
              className="rc-slider-wrapper"
              id="prompter-scroll-speed-slider"
            >
              <TooltipSlider
                min={0}
                max={AutoScrollSpeeds.length - 1}
                step={1}
                tipFormatter={this._autoScrollTipFormatter}
                value={autoScrollSpeedIndex}
                onChange={this._setAutoScrollSpeed}
              />
              <span className="slider-value">
                {AutoScrollSpeeds[autoScrollSpeedIndex].displayValue}
              </span>
            </div>
          </span>
        </span>
        <span
          className={classNames(animation, 'featured-utility-panel-slider')}
        >
          <span className={classNames(loading)}>
            <div className="fullscreen-switch-featured-text">
              Prompter Width
              <WithTooltip
                delay={100}
                placement="top"
                tip={`Use ${prompterWidthHotkey} and ← or → to adjust`}
              >
                <div>
                  <Icon name="info-circle" />
                </div>
              </WithTooltip>
            </div>
            <div className="rc-slider-wrapper" id="prompter-width-slider">
              <TooltipSlider
                min={0}
                max={PrompterWidths.length - 1}
                step={1}
                value={prompterWidthSliderIndex}
                onChange={this._setPrompterWidth}
              />
              <span className="slider-value">{prompterWidthIndex}</span>
            </div>
          </span>
        </span>
      </div>
    );
  }

  _autoScrollTipFormatter(value) {
    return `${AutoScrollSpeeds[value].displayValue}`;
  }

  _setAutoScrollSpeed(value) {
    FullScreenCuesheetActions.setFeaturedAutoScrollSpeed(value);
  }

  _setPrompterWidth(value) {
    this.setState({ prompterWidthSliderIndex: value });
    throttledSetPrompterWidth(value);
  }

  _setLineHeight(e) {
    this.setState({ lineHeightSliderIndex: e });
    this.throttledSetLineHeight(e);
  }

  _setZoom(e) {
    this.setState({ zoomSliderIndex: e });
    this.throttledSetZoom(e);
  }

  _getFontWeightButtonNode(featuredFontWeight) {
    const { loading, animation } = this._getLoadingClasses();

    return (
      <div
        className={classNames(
          animation,
          'featured-utility-panel-toggle-wrapper',
        )}
      >
        <span className={classNames(loading, 'featured-utility-panel-row')}>
          <div
            className="featured-utility-panel-toggle-switch"
            id="prompter-bold-toggle"
          >
            <ToggleSwitch
              on={featuredFontWeight === FontWeights.bold}
              onClick={this._onToggleBold}
              height={20}
              width={30}
            />
          </div>
          <div className="featured-utility-panel-toggle-text">Bold font</div>
        </span>
        <WithTooltip
          delay={100}
          placement="top"
          tip="Switch between bold and regular font weight for prompter text"
        >
          <div>
            <Icon name="info-circle" />
          </div>
        </WithTooltip>
      </div>
    );
  }

  _onToggleBold() {
    const { featuredFontWeight, onSettingsChange } = this.props;
    const { bold, regular } = FontWeights;
    const nextWeight = featuredFontWeight === regular ? bold : regular;

    onSettingsChange('featuredFontWeight', nextWeight);
  }

  _getItemTitleToggleNode(prompterItemInfoEnabled) {
    const { loading, animation } = this._getLoadingClasses();

    return (
      <div
        title="Item Title Toggle"
        className={classNames(
          animation,
          'featured-utility-panel-toggle-wrapper',
        )}
      >
        <span className={classNames(loading)}>
          <div
            id="prompter-item-info-toggle"
            className="featured-utility-panel-toggle-switch"
          >
            <ToggleSwitch
              on={prompterItemInfoEnabled || false}
              onClick={this._onToggleItemInfo}
              height={20}
              width={30}
            />
          </div>
          <div className="featured-utility-panel-toggle-text">Item info</div>
        </span>
        <WithTooltip
          delay={100}
          placement="top"
          tip="Switch between all capitalized or original casing for prompter text"
        >
          <div>
            <Icon name="info-circle" />
          </div>
        </WithTooltip>
      </div>
    );
  }

  _onToggleItemInfo() {
    const { onSettingsChange, prompterItemInfoEnabled } = this.props;
    const enabled = !prompterItemInfoEnabled;

    onSettingsChange('prompterItemInfoEnabled', enabled);
  }

  _getSingleItemToggleNode(prompterSingleItemEnabled) {
    const { loading, animation } = this._getLoadingClasses();

    return (
      <div
        title="Single Item Toggle"
        className={classNames(
          animation,
          'featured-utility-panel-toggle-wrapper',
        )}
      >
        <span className={classNames(loading)}>
          <div
            id="prompter-single-item-toggle"
            className="featured-utility-panel-toggle-switch"
          >
            <ToggleSwitch
              on={prompterSingleItemEnabled || false}
              onClick={this._toggleSingleItem}
              height={20}
              width={30}
            />
          </div>
          <div className="featured-utility-panel-toggle-text">Single Item</div>
        </span>
        <WithTooltip
          delay={100}
          placement="top"
          tip="Enable or disable the showing of one cell at a time"
        >
          <div>
            <Icon name="info-circle" />
          </div>
        </WithTooltip>
      </div>
    );
  }

  _toggleSingleItem() {
    const { prompterSingleItemEnabled, onSettingsChange } = this.props;
    const enabled = !prompterSingleItemEnabled;
    onSettingsChange('prompterSingleItemEnabled', enabled);
  }

  _getRealTimeToggleNode(prompterRealTimeEditsEnabled) {
    const { loading, animation } = this._getLoadingClasses();
    return (
      <div
        title="Single Item Toggle"
        className={classNames(
          animation,
          'featured-utility-panel-toggle-wrapper',
        )}
      >
        <span className={classNames(loading)}>
          <div
            id="prompter-realtime-toggle"
            className="featured-utility-panel-toggle-switch"
          >
            <ToggleSwitch
              on={prompterRealTimeEditsEnabled || false}
              onClick={this._toggleRealTimeItem}
              height={20}
              width={30}
            />
          </div>
          <div className="featured-utility-panel-toggle-text">
            Incoming changes
          </div>
        </span>
        <WithTooltip
          delay={100}
          placement="top"
          tip="Allow or disallow incoming changes from other editors. Changes you make will always update the rundown for all users."
        >
          <div>
            <Icon name="info-circle" />
          </div>
        </WithTooltip>
      </div>
    );
  }

  _toggleRealTimeItem() {
    const { prompterRealTimeEditsEnabled, onSettingsChange } = this.props;
    onSettingsChange(
      'prompterRealTimeEditsEnabled',
      !prompterRealTimeEditsEnabled,
    );
  }

  _retrieveLatestNode(prompterRealTimeEditsEnabled) {
    if (prompterRealTimeEditsEnabled) return null;

    const buttonText = ' Retrieve latest';

    const { loading, animation } = this._getLoadingClasses();

    return (
      <div className={classNames(animation, 'retrieve-latest-button-wrapper')}>
        <span className={classNames(loading)}>
          <Button
            data-testid="retrieveLatestButton"
            onClick={FullScreenCuesheetActions.refreshAllRows}
          >
            <Icon name="refresh" />
            {buttonText}
          </Button>
        </span>
      </div>
    );
  }

  _getReadArrowButtonNode(prompterReadArrowEnabled) {
    const { loading, animation } = this._getLoadingClasses();

    return (
      <div
        className={classNames(
          animation,
          'featured-utility-panel-toggle-wrapper',
        )}
      >
        <span className={classNames(loading)}>
          <div
            id="prompter-arrow-toggle"
            className="featured-utility-panel-toggle-switch"
          >
            <ToggleSwitch
              on={prompterReadArrowEnabled || false}
              onClick={this._toggleReadArrow}
              height={20}
              width={30}
            />
          </div>
          <div className="featured-utility-panel-toggle-text">Read arrow</div>
        </span>
        <WithTooltip
          delay={100}
          placement="top"
          tip="Enable or disable the read arrow"
        >
          <div>
            <Icon name="info-circle" />
          </div>
        </WithTooltip>
      </div>
    );
  }

  _toggleReadArrow() {
    const { onSettingsChange, prompterReadArrowEnabled } = this.props;
    const enabled = !prompterReadArrowEnabled;

    onSettingsChange('prompterReadArrowEnabled', enabled);
  }

  _getForceCapsButtonNode(featuredCapitalization) {
    const { loading, animation } = this._getLoadingClasses();

    return (
      <div
        className={classNames(
          animation,
          'featured-utility-panel-toggle-wrapper',
        )}
      >
        <span className={classNames(loading)}>
          <div
            id="prompter-capitalization-toggle"
            className="featured-utility-panel-toggle-switch"
          >
            <ToggleSwitch
              on={featuredCapitalization || false}
              onClick={this._toggleCaps}
              height={20}
              width={30}
            />
          </div>
          <div className="featured-utility-panel-toggle-text">All caps</div>
        </span>
        <WithTooltip
          delay={100}
          placement="top"
          tip="Switch between all capitalized or original casing for prompter text"
        >
          <div>
            <Icon name="info-circle" />
          </div>
        </WithTooltip>
      </div>
    );
  }

  _toggleCaps() {
    const { onSettingsChange, featuredCapitalization } = this.props;
    const enabled = !featuredCapitalization;

    onSettingsChange('featuredCapitalization', enabled);
  }

  _getMirrorTextButtonNode(prompterTextMirror) {
    const { loading, animation } = this._getLoadingClasses();

    return (
      <div
        className={classNames(
          animation,
          'featured-utility-panel-toggle-wrapper',
        )}
      >
        <span className={classNames(loading)}>
          <div
            id="prompter-horizontal-mirror-toggle"
            className="featured-utility-panel-toggle-switch"
          >
            <ToggleSwitch
              on={prompterTextMirror || false}
              onClick={this._toggleTextMirror}
              height={20}
              width={30}
            />
          </div>
          <div className="featured-utility-panel-toggle-text">
            Horizontal mirror
          </div>
        </span>
        <WithTooltip
          delay={100}
          placement="top"
          tip="Switch between horizontal text mirror or normal text view"
        >
          <div>
            <Icon name="info-circle" />
          </div>
        </WithTooltip>
      </div>
    );
  }

  _toggleTextMirror() {
    const { onSettingsChange, prompterTextMirror } = this.props;

    const enabled = !prompterTextMirror;
    onSettingsChange('prompterTextMirror', enabled);
  }

  _getMirrorVerticalTextButtonNode() {
    const { prompterTextVerticalMirror } = this.props;

    const { loading, animation } = this._getLoadingClasses();

    return (
      <div
        className={classNames(
          animation,
          'featured-utility-panel-toggle-wrapper',
        )}
      >
        <span className={classNames(loading)}>
          <div
            id="prompter-vertical-mirror-toggle"
            className="featured-utility-panel-toggle-switch"
          >
            <ToggleSwitch
              on={prompterTextVerticalMirror || false}
              onClick={this._toggleVerticalMirror}
              height={20}
              width={30}
            />
          </div>
          <div className="featured-utility-panel-toggle-text">
            Vertical mirror
          </div>
        </span>
      </div>
    );
  }

  _toggleVerticalMirror() {
    const { onSettingsChange, prompterTextVerticalMirror } = this.props;

    const enabled = !prompterTextVerticalMirror;
    onSettingsChange('prompterTextVerticalMirror', enabled);
  }

  _getActivityAuditNode(activityAudit) {
    let momDate = '',
      dateAndTime = '',
      userName = '';

    if (activityAudit) {
      const { user, createdOn } = activityAudit;
      momDate = moment(createdOn);
      dateAndTime = `${momDate.format('M/D/YY')} @ ${momDate.format(
        'h:mm:ss',
      )}`;
      userName = `${user.firstName} ${user.lastName}`;
    }

    const { loading, animation } = this._getLoadingClasses();

    return (
      <div className="featured-utility-panel-content__saved">
        <p>Last saved:</p>
        <p>
          <span className={animation}>
            <span className={loading}>{dateAndTime}</span>
          </span>
        </p>
        <p>
          <span className={animation}>
            <span className={loading}>{userName}</span>
          </span>
        </p>
      </div>
    );
  }

  _getReadNode(text) {
    const { loading, animation } = this._getLoadingClasses();

    const stats = readingTime(text, { wordsPerMinute: 128 });

    let minutes = 0;
    let seconds = 0;

    if (stats.minutes < 1) {
      seconds = Math.round(stats.minutes * 60);
    } else {
      const readTime = stats.minutes.toString().split('.');
      minutes = readTime[0] || 0;
      seconds = readTime[1]
        ? Math.round(parseFloat(`.${readTime[1]}`) * 60)
        : 0;
    }

    let displayTime = '';
    if (minutes) displayTime += `${minutes}m`;
    if (seconds) displayTime += `${seconds}s`;

    return (
      <div className="featured-utility-panel-content__read">
        <p>
          Words -
          <span className={animation}>
            <span className={loading}> {stats.words}</span>
          </span>
        </p>
        <p>
          Characters -
          <span className={animation}>
            <span className={loading}> {text.length}</span>
          </span>
        </p>
        <p>
          Read time -
          <span className={animation}>
            <span className={loading}> {displayTime}</span>
          </span>
        </p>
      </div>
    );
  }

  _handleShowSelection(show) {
    const { teamId, eventId } = this.props;

    return RouteActions.goToShowDisplayType(
      { teamId, eventId, showId: show.get('_id') },
      show.get('displayType'),
    );
  }

  _getSettingsTab() {
    const {
      featuredFontWeight,
      prompterReadArrowEnabled,
      featuredCapitalization,
      prompterTextMirror,
      prompterItemInfoEnabled,
      prompterSingleItemEnabled,
      prompterRealTimeEditsEnabled,
      activityAudit,
      text,
      //user,
      //crew,
    } = this.props;
    //const { operator } = this.state;

    return (
      <div>
        <div className="featured-utility-panel-btn-group-wrapper">
          {this._getColumnSelectorNode()}
          {this._getRealTimeToggleNode(prompterRealTimeEditsEnabled)}
          {this._retrieveLatestNode(prompterRealTimeEditsEnabled)}
          {this._getFontWeightButtonNode(featuredFontWeight)}
          {this._getReadArrowButtonNode(prompterReadArrowEnabled)}
          {this._getForceCapsButtonNode(featuredCapitalization)}
          {this._getMirrorTextButtonNode(prompterTextMirror)}
          {this._getItemTitleToggleNode(prompterItemInfoEnabled)}
          {this._getSingleItemToggleNode(prompterSingleItemEnabled)}
          {/*
            <div className="showcaller-dropdown-wrapper">
            <p>Showcaller:</p>
            <Dropdown
              config={this._getUserSelectorConfig(user, operator, crew)}
            />
          </div>
          */}
        </div>
        <div className="utility-panel-activity-read-wrapper">
          {this._getActivityAuditNode(activityAudit)}
          {this._getReadNode(text)}
        </div>
      </div>
    );
  }

  _setStylesTabActive() {
    this.setState({ activeTab: 'styles' });
  }

  _setSettingsTabActive() {
    this.setState({ activeTab: 'settings' });
  }

  _getTabs() {
    const { activeTab } = this.state;
    const { animation, loading } = this._getLoadingClasses();
    return (
      <div className={classNames(animation, 'tabs')}>
        <div className={classNames(loading)}>
          <button
            onClick={this._setStylesTabActive}
            className={classNames({ active: activeTab === 'styles' })}
          >
            Styles
          </button>
          <button
            onClick={this._setSettingsTabActive}
            className={classNames({ active: activeTab === 'settings' })}
          >
            Settings
          </button>
          <div className="divider"></div>
        </div>
      </div>
    );
  }

  _getActiveTab() {
    const tabs = {
      styles: this._getStylesTab,
      settings: this._getSettingsTab,
    };
    return tabs[this.state.activeTab]();
  }

  _getUserSelectorConfig(user, operator, crew) {
    const name = operator
      ? `${operator.get('firstName')} ${operator.get('lastName')}`
      : `${user.get('firstName')} ${user.get('lastName')}`;

    return Map({
      noCaret: false,
      icon: null,
      content: name,
      items: this._getOrderedMapOfItems(crew),
    });
  }

  _getOrderedMapOfItems(crew) {
    const crewList = crew.get('list');

    return crewList.map((user) => {
      const name = `${user.get('firstName')} ${user.get('lastName')}`;
      return Map({
        type: 'link',
        content: name,
        onClick: () => this._setPreferredOperator(user),
      });
    });
  }

  _setPreferredOperator(user) {
    this.setState({ operator: user });
  }
}

export default UtilityPanel;

const throttledSetPrompterWidth = _.debounce(
  FullScreenCuesheetActions.setPrompterWidth,
  500,
);
